import Component from 'vue-class-component';
import {RegistrationVue} from '@/registration-vue';
import './clubcard-details-entry.scss';
import {loadSecurityQuestions} from '@/utils';

@Component({template: require('./clubcard-details-entry.html')})
export class ClubCardDetailsEntryPage extends RegistrationVue {

  dateOfBirthFocused: boolean = false;
  loading: boolean = false;

  mounted() {
    this.$validator.updateDictionary({
                                       en: {
                                         custom: {
                                           dateOfBirth: {
                                             required: 'Please enter your date of birth',
                                             date_format: 'Date of birth should be in the format DD/MM/YYYY'
                                           }
                                         }
                                       }
                                     });
  }

  onResAddressClick() {
    this.navigate('address-entry', {type: 'res'});
  }

  onPostAddressClick() {
    this.navigate('address-entry', {type: 'post'});
  }

  onPostAddressFocus() {
    (<HTMLInputElement>this.$refs.postField).blur();
    this.onPostAddressClick()
  }

  onResAddressFocus() {
    (<HTMLInputElement>this.$refs.resField).blur();
    this.onResAddressClick()
  }

  get resAddress() {
    return this.formatAddress(this.$store.state.resAddress);
  }

  get postAddress() {
    return this.formatAddress(this.$store.state.postAddress);
  }

  formatAddress(addressStateModel): string {
    if (!addressStateModel.isManual) {
      return addressStateModel.address
    } else {

      let formattedAddress = '';

      if (addressStateModel.manualAddress.ruralDeliveryNumber) {
        formattedAddress += addressStateModel.manualAddress.ruralDeliveryNumber + ', '
      }

      if (addressStateModel.manualAddress.unit) {
        formattedAddress += addressStateModel.manualAddress.unit + ' '
      }

      formattedAddress += addressStateModel.manualAddress.streetNumber + ' ' + addressStateModel.manualAddress.streetName + ', ';

      if (addressStateModel.manualAddress.suburb) {
        formattedAddress += addressStateModel.manualAddress.suburb + ', ';
      }

      formattedAddress += addressStateModel.manualAddress.city + ' ' + addressStateModel.manualAddress.postcode;

      return formattedAddress;
    }
  }

  get submitDisabled() {
    return !this.$store.state.firstName.length ||
      !this.$store.state.lastName ||
      !this.$store.state.dateOfBirth ||
      !this.$store.state.title ||
      this.$store.state.title == 'dr' && !this.$store.state.gender ||
      !this.resAddress ||
      !this.$store.state.samePostalAddress && !this.postAddress
  }

  next() {
    this.doIfFormIsValid(() => {
      this.loading = true;
      this.$store.state.isFullShopper = true;

      loadSecurityQuestions(this.$store).then(() => {
        this.navigate('security-entry');
      }).catch(() => {
        this.loading = false;
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/forms/clubcard-details-entry/clubcard-details-entry.ts